<ng-content select=".header-title"></ng-content>
<ng-content select=".header-actions"></ng-content>
<ng-content></ng-content>